import { Link } from 'react-router-dom';

const friendLinks = [
  { label: '动画资讯站', to: '/about' },
  { label: '剧集资料库', to: '/category' },
  { label: '角色档案', to: '/about' },
  { label: '漫评社区', to: '/about' },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 border-t border-primary-900/40 mt-20">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-9 h-9 rounded-full bg-gradient-to-br from-primary-500 to-secondary-500 flex items-center justify-center text-background-50">
                <i className="ri-moon-clear-fill text-lg"></i>
              </span>
              <span className="font-heading font-bold text-lg text-foreground-50">无颜之月 · 第一季全集</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed max-w-md">
              专注「无颜之月」动画第一季全集的剧集索引、剧情介绍与观看指南。本平台内容为演示示例，视频播放为功能演示，完整版内容敬请关注正版渠道。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-foreground-100 mb-4 tracking-wide">快速导航</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-foreground-400 hover:text-accent-400 transition-colors">
                  动画首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="text-foreground-400 hover:text-accent-400 transition-colors">
                  剧集分类
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-foreground-400 hover:text-accent-400 transition-colors">
                  搜索剧集
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-400 hover:text-accent-400 transition-colors">
                  关于本站
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-foreground-100 mb-4 tracking-wide">友情链接</h3>
            <ul className="space-y-2 text-sm">
              {friendLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-foreground-400 hover:text-accent-400 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-900/40 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-foreground-500">
          <p>© 2026 无颜之月动漫第一季全集 · 本站为演示站点，剧情与数据均为虚构示例。</p>
          <p>仅供学习与演示使用，不含任何未授权内容。</p>
        </div>
      </div>
    </footer>
  );
}